module.exports = __webpack_public_path__ + "static/img/expand.cf4a6268.png";